module.exports = __webpack_public_path__ + "img/prizeDraw.8af70dad.png";